import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { onBrandFor } from '@/shared/branding/contrast'

/**
 * White-label identita partnera.
 *
 * Zdrojom je profil partnera z API; kým sa nenačíta, platí predvolený brand
 * importéra z `tokens.css`. Ukladá sa iba to, čo partner naozaj mení:
 * farba, logo a názov.
 */
export interface PartnerBranding {
	readonly companyName: string
	readonly brandHex: string
	readonly logoUrl: string | null
}

export const useBrandingStore = defineStore('branding', () => {
	const companyName = ref('MaxDoors')
	const brandHex = ref('#059669')
	const logoUrl = ref<string | null>(null)

	/** Odvodené, nikdy nastavované — pozri `shared/branding/contrast.ts`. */
	const onBrandHex = computed(() => onBrandFor(brandHex.value))

	/**
	 * Iniciálky pre zástupný znak loga.
	 *
	 * Fallback bez loga je podľa MASTER.md §2 textový wordmark; iniciálky sa
	 * používajú v zbalenom sidebare, kde na wordmark nie je miesto.
	 */
	const initials = computed(() =>
		companyName.value
			.split(/\s+/)
			.slice(0, 2)
			.map((word) => word.charAt(0))
			.join('')
			.toUpperCase(),
	)

	function apply(branding: PartnerBranding): void {
		companyName.value = branding.companyName
		brandHex.value = branding.brandHex
		logoUrl.value = branding.logoUrl
	}

	return { companyName, brandHex, logoUrl, onBrandHex, initials, apply }
})
